import { IconButton, Tooltip, styled } from "@mui/material";

import clsx from "clsx";
import { useAppDispatch } from "../../../redux/store";
import { IWithClassName } from "../../../theme/default.theme";
import { RunStatus } from "../enum/run-status";
import { IListBuilderTableDto } from "../interface/dto/list-builder-table-list.dto";
import { listBuilderTableDownloadAction } from "../redux/list-builder-table-page.action";
interface IOwnProps {
    listBuilder: IListBuilderTableDto;
}

const ListBuilderDownload = ({
    className,
    listBuilder,
}: IWithClassName & IOwnProps) => {
    const dispatch = useAppDispatch();

    const isButtonDisabled = listBuilder?.lastRunStatus !== RunStatus.Ready;

    const handleDownloadClick = () => {
        if (listBuilder) {
            dispatch(listBuilderTableDownloadAction(listBuilder.listBuilderId));
        }
    };

    return (
        <span className={className}>
            <Tooltip title="Download this List Builder">
                <span>
                    <IconButton
                        onClick={handleDownloadClick}
                        aria-label="download"
                        disabled={isButtonDisabled}
                        className={clsx({ disabledButton: isButtonDisabled })}
                    >
                        <img src="/assets/download-icon.svg" alt="Download" />
                    </IconButton>
                </span>
            </Tooltip>
        </span>
    );
};

export default styled(ListBuilderDownload)(() => ({
    ".disabledButton": {
        opacity: 0.5,
    },
}));
